import { Button, DialogActions } from '@mui/material';
import type { UploadReceiptActionsProps } from '../../../types/uploadReceiptDialog';

const UploadReceiptActions = ({
  uploading,
  modeSwitching,
  perspectiveLoading,
  selectedFile,
  selectedStore,
  locationRequired,
  selectedLocation,
  locationsLoading,
  locationsResolved,
  onClose,
  onUpload,
}: UploadReceiptActionsProps) => {
  return (
    <DialogActions sx={{ p: 3, pt: 1 }}>
      <Button
        variant="outlined"
        onClick={onClose}
        disabled={uploading || modeSwitching}
        size="large"
        sx={{
          color: '#2C6CA0',
          borderColor: 'grey.300',
          borderRadius: '8px',
          textTransform: 'none',
          backgroundColor: '#ffffff',
          fontWeight: 600,
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onUpload}
        variant="contained"
        sx={{
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '15px',
          backgroundColor: '#2C6CA0',
        }}
        disabled={
          !selectedFile
          || !selectedStore
          || (locationRequired && !selectedLocation)
          || uploading
          || modeSwitching
          || perspectiveLoading
          || locationsLoading
          || !locationsResolved
        }
      >
        {uploading ? 'Uploading...' : 'Upload Receipt'}
      </Button>
    </DialogActions>
  );
};

export default UploadReceiptActions;
